import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be15ec10&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be15ec10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be15ec10')) {
      api.createRecord('be15ec10', component.options)
    } else {
      api.reload('be15ec10', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be15ec10&scoped=true&", function () {
      api.rerender('be15ec10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/compoments/Tender/index.vue"
export default component.exports